import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Count} from "./count";
import {Progress} from "./progress";
import "./button";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
    // Count numbers
    const numberElements = document.querySelectorAll<HTMLElement>("[data-count]");
    numberElements?.forEach((number) => {
        new Count(number);
    });

    // Progress
    const elements = document.querySelectorAll<HTMLElement>("[data-progress]");
    elements?.forEach((trigger) => {
       new Progress(trigger);
    });
})